/* eslint-disable @angular-eslint/prefer-inject -- leave alone for now */
import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';
import { ErrorObject } from '@safarilaw-webapp/shared/error-handling-message-parser';
import { CssLoaderService } from '@safarilaw-webapp/shared/ui-kit/cssLoader';

export const GATEWAY_TIMEOUT_URLS = new InjectionToken<string>('Gateway Timeout Urls');
@Component({
  selector: 'sl-root-gateway-timeout',
  templateUrl: './gateway-timeout.component.html',
  styleUrls: ['./gateway-timeout.component.scss']
})
export class GatewayTimeoutComponent extends SafariInjector implements OnInit {
  errorObject: ErrorObject;
  cssLoaderService: CssLoaderService;
  constructor(@Inject(GATEWAY_TIMEOUT_URLS) public gatewayTimeoutUrls) {
    super();
    this.cssLoaderService = this.inject(CssLoaderService);
  }

  ngOnInit() {
    this.cssLoaderService.load('safari-common-page');
    this.errorObject = window['safari-error-state']?.errorObject;
  }
}
